import { Paper } from "@mui/material";
import {
  BarChart, Bar,
  XAxis, YAxis,
  Tooltip, ResponsiveContainer, Cell,
} from "recharts";
import { ChartContainer } from "./charts";

const CustomTooltip = (props: any) => {
  const { active, payload, label, color, theme } = props;
  if (active && payload && payload.length) {
    return (
      <Paper className="p-2" style={{backgroundColor: theme.colors.mediumGrey, opacity: 0.9}}>
        <p className="label" style={{color: color}}>{`${label} : ${payload[0].value}`}</p>
      </Paper>
    );
  }
  return null;
};

interface HorizontalBarChartProps {
  data: any;
  theme: any;
}

const HorizontalBarChart = ({data, theme}: HorizontalBarChartProps) => {
  return (
    <ChartContainer>
      <ResponsiveContainer height={200}>
        <BarChart data={data} layout="vertical">
          <XAxis 
            type="number" 
            stroke={theme.colors.textColor}
          />
          <YAxis 
            tickLine={false}
            tickMargin={20}
            dataKey="name"
            type="category"
            width={110}
            interval={0}
            textAnchor= "end"
            stroke={theme.colors.textColor}
          />
          <Tooltip content={<CustomTooltip color={theme.colors.textColor} theme={theme}/>} cursor={{fill: 'transparent'}}/>
          {/* <Legend /> */}
          <Bar dataKey="value">
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};

export default HorizontalBarChart;
